'use strict';

/* =========================================================================
   BASIS — Hero photo slider
   Port basis-redesign/assets/js/script.js → initHeroSlider().
   La durée du slide est lue depuis data-slide-duration sur .basis-hero__photo
   (exposé par le schema Shopify, en millisecondes).

   Classes namespacées en .basis-hero* pour éviter la collision avec la
   classe .hero native d'Horizon (qui écrasait notre min-height → slider à 0).
   ========================================================================= */

function initBasisHeroSlider(root) {
  const scope = root || document;
  const photoContainer = scope.querySelector('.basis-hero__photo');
  if (!photoContainer) return;

  // Évite d'empiler plusieurs intervals si la section est ré-initialisée
  // (theme editor : shopify:section:load se déclenche à chaque édition).
  if (photoContainer._basisSliderTimer) {
    clearInterval(photoContainer._basisSliderTimer);
    photoContainer._basisSliderTimer = null;
  }

  const slides = photoContainer.querySelectorAll('.basis-hero__slide');
  if (slides.length < 2) return;

  // Lit la durée depuis le DOM (ms), fallback 2000ms
  const duration = parseInt(photoContainer.dataset.slideDuration, 10) || 2000;

  let currentIndex = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  // Respect prefers-reduced-motion : pas d'auto-rotation
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    showSlide(0);
    return;
  }

  showSlide(0);
  photoContainer._basisSliderTimer = setInterval(nextSlide, duration);
}

document.addEventListener('DOMContentLoaded', () => initBasisHeroSlider());

// Theme editor : ré-initialise quand la section est rechargée / éditée.
document.addEventListener('shopify:section:load', (e) => initBasisHeroSlider(e.target));
